import kr from './kr';
import en from './en';
import ja from './ja';
import tc from './tc';
import th from './th';

export default {
  kr,
  en,
  tc,
  ja,
  th
}